module.exports = __webpack_public_path__ + "static/media/traffic-light-stop.0489621d.svg";